import BlogListCard from "../components/blog/blog_card";
import cardData from "../data/blog.json";
export default function BlogList() {
    const recent_news_card_data = []; // Populate this array with recent blog data as needed
    document.title = "Blog - CGES.CLUB";

    return (
        <>

            <div class="uk-grid" data-uk-grid>
                <div class="uk-width-3-4@l uk-width-3-5@m">
                    <h3 className="uk-text-lead">Blogs</h3>
                    <div class="uk-grid uk-grid-medium uk-child-width-1-2@l uk-child-width-2-2@m uk-child-width-1-1@s" uk-grid="masonry: true">


                        {cardData.map((card, index) => (
                            <BlogListCard key={index} data={card} />
                        ))}


                    </div>


                </div>

                <div class="uk-width-1-4@l uk-width-2-5@m">

                    <aside class="l-sidebar">
                        {/* <div class="widget widget-search section-sidebar bg-light">
                            <div class="widget-title bg-dark">search</div>
                            <div class="widget-inner">
                                <form class="form-sidebar" id="search-global-form">
                                    <input class="form-sidebar__input form-control" type="search" placeholder="keyword" />
                                    <button class="form-sidebar__btn"><i class="ic icon-magnifier"></i></button>
                                </form>
                            </div>
                        </div> */}

                        {/* <section class="widget section-sidebar bg-light">
                            <h3 class="widget-title bg-dark">categories</h3>
                            <div class="widget-content">
                                <div class="widget-inner">
                                    <ul class="widget-list list list-mark-4">

                                        <li class="widget-list__item"><a class="widget-list__link" href="blog-post.html"> Fighting games</a></li>
                                        <li class="widget-list__item"><a class="widget-list__link" href="blog-post.html"> Beat 'em up games</a></li>
                                        <li class="widget-list__item"><a class="widget-list__link" href="blog-post.html"> Stealth game</a></li>
                                        <li class="widget-list__item"><a class="widget-list__link" href="blog-post.html">Action-adventure</a></li>
                                        <li class="widget-list__item"><a class="widget-list__link" href="blog-post.html"> Survival horror</a></li>
                                        <li class="widget-list__item"><a class="widget-list__link" href="blog-post.html">Text adventures</a></li>
                                        <li class="widget-list__item"><a class="widget-list__link" href="blog-post.html"> Graphic adventures</a></li>
                                        <li class="widget-list__item"><a class="widget-list__link" href="blog-post.html"> Interactive movie</a></li>


                                    </ul>
                                </div>
                            </div>
                        </section> */}

                        <section class="widget section-sidebar bg-light">
                            <h3 class="widget-title bg-dark"><i class="ic icon-calendar"></i>recent blogs</h3>
                            <div class="widget-content">
                                <div class="widget-inner">

                                    {recent_news_card_data.length > 0 ? (
                                        <>
                                            {recent_news_card_data.map((card, index) => (
                                                <RecentBlog key={index} data={card} />
                                            ))}
                                        </>
                                    ) : (

                                        <p>No recent blogs available</p>

                                    )}

                                </div>
                            </div>
                        </section>

                        {/* <section class="widget section-sidebar bg-light">
                            <h3 class="widget-title bg-dark">tags cloud</h3>
                            <div class="widget-content">
                                <div class="widget-inner">
                                    <ul class="list-tags list-unstyled">
                                        <li class="list-tags__item"><a class="list-tags__link" href="blog-post.html">Article</a></li>
                                        <li class="list-tags__item"><a class="list-tags__link" href="blog-post.html">Keyword</a></li>
                                        <li class="list-tags__item"><a class="list-tags__link" href="blog-post.html">Domain</a></li>
                                        <li class="list-tags__item"><a class="list-tags__link" href="blog-post.html">Backlink</a></li>
                                        <li class="list-tags__item"><a class="list-tags__link" href="blog-post.html">Compressor</a></li>
                                        <li class="list-tags__item"><a class="list-tags__link" href="blog-post.html">Video</a></li>
                                        <li class="list-tags__item"><a class="list-tags__link" href="blog-post.html">Facebook</a></li>
                                        <li class="list-tags__item"><a class="list-tags__link" href="blog-post.html">Gaming</a></li>
                                        <li class="list-tags__item"><a class="list-tags__link" href="blog-post.html">Word</a></li>
                                        <li class="list-tags__item"><a class="list-tags__link" href="blog-post.html">PDF</a></li>
                                        <li class="list-tags__item"><a class="list-tags__link" href="blog-post.html">RGB</a></li>
                                        <li class="list-tags__item"><a class="list-tags__link" href="blog-post.html">GIF Converter</a></li>
                                    </ul>
                                </div>
                            </div>
                        </section> */}

                    </aside>
                </div>

            </div>
        </>
    );
}